module.exports = __webpack_public_path__ + "img/cisco-meraki-logo.42306c25.webp";